/* ==========================================================================
   Mondō London — continuous page scroll
   Fine-pointer browsers receive restrained Lenis wheel smoothing. Touch and
   reduced-motion visitors stay entirely native. The former hero boundary snap
   is intentionally retired: scroll position always follows the reader.
   ========================================================================== */
(function () {
  'use strict';
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia
    ? window.matchMedia('(hover: hover) and (pointer: fine)')
    : { matches: false };
  var mobileViewport = window.matchMedia
    ? window.matchMedia('(max-width: 899px)')
    : { matches: true };
  var useLenis = typeof Lenis !== 'undefined' && !reducedMotion && finePointer.matches && !mobileViewport.matches;
  var lenis = null;

  if (useLenis) {
    lenis = new Lenis({
      lerp: 0.1,
      wheelMultiplier: 1,
      smoothWheel: true
    });
    window.lenis = lenis;

    var rafId = 0;
    function startRaf() { if (!rafId && !document.hidden) rafId = requestAnimationFrame(raf); }
    function raf(time) {
      rafId = 0;
      if (!lenis || document.hidden) return;
      lenis.raf(time);
      startRaf();
    }
    startRaf();
    document.addEventListener('visibilitychange', function () {
      if (document.hidden && rafId) { cancelAnimationFrame(rafId); rafId = 0; }
      else startRaf();
    });

    function focusAnchorTarget(target) {
      if (!target || typeof target.focus !== 'function') return;
      var temporaryTabindex = !target.hasAttribute('tabindex');
      if (temporaryTabindex) target.setAttribute('tabindex', '-1');
      try { target.focus({ preventScroll: true }); }
      catch (err) { target.focus(); }
      if (temporaryTabindex) target.removeAttribute('tabindex');
    }

    /* Fine-pointer in-page anchors share the same measured glide. Native-scroll
       devices retain the browser's own anchor and history behaviour. */
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented) return;
      var a = e.target.closest ? e.target.closest('a[href^="#"]') : null;
      if (!a || a.closest('.skip-links') || a.hasAttribute('data-consent-summon') || a.hasAttribute('data-nl-summon')) return;
      var hash = a.getAttribute('href');
      if (!hash || hash === '#') return;
      var el = document.querySelector(hash);
      if (!el) return;
      e.preventDefault();
      lenis.scrollTo(hash === '#content' ? 0 : el, {
        onComplete: function () { focusAnchorTarget(el); }
      });
      if (hash !== '#content') { try { history.pushState(null, '', hash); } catch (err) {} }
    });
  }

  /* Header contrast follows the hero boundary without controlling scroll. */
  if (!document.body.classList.contains('template-index')) return;
  var hero = document.querySelector('.hero');
  if (!hero) return;
  var header = document.querySelector('.site-header');
  var heroEnd = 0;
  function measureHero() { heroEnd = Math.round(hero.offsetTop + hero.offsetHeight); overHero(); }
  function overHero() {
    var headerHeight = header ? header.offsetHeight : 0;
    if (header) header.classList.toggle('over-hero', window.scrollY < heroEnd - headerHeight);
  }
  measureHero();
  window.addEventListener('load', measureHero);
  window.addEventListener('scroll', overHero, { passive: true });
  var rT = null;
  window.addEventListener('resize', function () {
    clearTimeout(rT);
    rT = setTimeout(function () {
      if (lenis && lenis.resize) lenis.resize();
      measureHero();
    }, 160);
  });
})();
